import React from 'react';
import InputImagenCV from './controladorVista/inputImagenCV';
import { IInputImagenCVProps } from './interfaces';

const InputImagen: React.FunctionComponent<IInputImagenCVProps> = (props) => <InputImagenCV {...props} />;

export default InputImagen;
